import { render, staticRenderFns } from "./app.header.vue?vue&type=template&id=8fcd01c6&scoped=true"
import script from "./app.header.vue?vue&type=script&lang=js"
export * from "./app.header.vue?vue&type=script&lang=js"
import style0 from "./app.header.vue?vue&type=style&index=0&id=8fcd01c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcd01c6",
  null
  
)

export default component.exports